export default (props) => ({
  __typename: 'ForgotPasswordBlock',
  isCandidate: Math.random() >= 0.5,
})
